import { locate, locateID } from "@xbs/lib-dom";
import { addMinutes } from "date-fns";
export function openEditor(ev, dispatch, id) {
    if (locateID(ev, "data-id")) {
        dispatch("action", {
            action: "edit-event",
            data: { id },
        });
    }
}
export function singleClickHandler(ev, dispatch, dateClick) {
    const id = locateID(ev, "data-id");
    if (id) {
        const node = locate(ev, "data-id");
        dispatch("action", {
            action: "select-event",
            data: { id, popup: true },
        });
        return node;
    }
    const toggle = locate(ev, "data-day-toggle");
    if (toggle && dateClick) {
        const date = locateID(ev, "data-cell");
        dispatch("action", {
            action: "set-date",
            data: { value: new Date(date) },
        });
        dispatch("action", {
            action: "set-mode",
            data: { value: dateClick },
        });
    }
}
export function navigationClick(ev, dispatch, locale) {
    const id = locateID(ev);
    if (!id)
        return;
    switch (id) {
        case "add":
            dispatch("action", {
                action: "edit-event",
                data: { add: { text: locale("New Event") } },
            });
            break;
        case "next":
        case "prev":
            dispatch("action", {
                action: "set-bound",
                data: { step: id === "next" ? 1 : -1 },
            });
            break;
        case "today":
            dispatch("action", {
                action: "set-date",
                data: { value: new Date() },
            });
            break;
        case "toggle-sidebar":
            dispatch("action", {
                action: "toggle-sidebar",
            });
            break;
        default:
            return;
    }
}
export function popupClick(name, event, dispatch, close, confirm, locale) {
    if (name === "edit") {
        dispatch("action", {
            action: "edit-event",
            data: { id: event.id },
        });
    }
    if (name === "delete") {
        dispatch("action", {
            action: "close-event-info",
            data: {},
        });
        const message = {
            type: "error",
            message: locale("confirmDelete"),
        };
        if (event.recurring) {
            dispatch("action", {
                action: "delete-event",
                data: { id: event.id, event },
            });
            return;
        }
        confirm(message)
            .then(() => {
            close();
            dispatch("action", {
                action: "delete-event",
                data: { id: event.id, event },
            });
            // eslint-disable-next-line @typescript-eslint/no-empty-function
        })
            .catch(() => { });
    }
}
export function dblClickOnGrid(ev, dispatch, model, config, locale) {
    const { readonly, editorOnDblClick, createEventOnDblClick, defaultEventDuration, } = config;
    if (readonly)
        return;
    const id = locateID(ev, "data-id");
    if (id && editorOnDblClick) {
        return dispatch("action", {
            action: "edit-event",
            data: { id },
        });
    }
    if (!id && createEventOnDblClick && model.getEventFromPosition) {
        const event = model.getEventFromPosition(locateID(ev, "data-cell"), "data-cell", ev, locale)?.eventData;
        if (!event)
            return;
        event.end_date = addMinutes(event.start_date, defaultEventDuration);
        dispatch("action", {
            action: `edit-event`,
            data: {
                add: event,
            },
        });
    }
}
export function dblClickOnYearCalendar(ev, dispatch) {
    const date = locateID(ev);
    if (!date)
        return;
    dispatch("action", {
        action: "set-date",
        data: { value: date },
    });
    dispatch("action", {
        action: `edit-event`,
        data: {
            add: {},
        },
    });
    ev.stopPropagation();
}
export function calendarSidebarActions(event, state, dispatch, confirm, calendar) {
    const { action, data } = event;
    switch (action) {
        case "show-popup":
            state.update(val => {
                return { ...val, ...data };
            });
            break;
        case "close":
            state.set({
                edit: false,
                calendar: null,
                pos: null,
            });
            break;
        case "edit":
            state.update(val => ({ ...val, calendar, pos: null, edit: true }));
            break;
        case "add":
            state.update(val => ({
                ...val,
                pos: null,
                calendar: null,
                edit: true,
            }));
            break;
        case "save":
            state.update(val => ({ ...val, calendar: null, edit: false }));
            dispatch("action", { ...data });
            break;
        case "delete": {
            const id = calendar.id;
            state.update(val => {
                return { ...val, pos: null, edit: false };
            });
            confirm({
                type: "error",
                message: "Are you sure you want to delete this calendar?",
            })
                .then(() => {
                dispatch("action", {
                    action: "delete-calendar",
                    data: { id },
                });
            })
                .catch(state.update(val => ({
                ...val,
                calendar: null,
                edit: false,
            })));
            break;
        }
    }
}
//# sourceMappingURL=handlers.js.map